import styles from './DashboardHeader.module.css';
import React, { useState } from "react";

import {
  Link
} from "react-router-dom";
import { StyleSheetManager } from 'styled-components';

function DashboardHeader() {

  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  if(click) {
    var itemstyles = styles.nav_options + " " + styles.active;
  }
  else{
    var itemstyles = styles.nav_options;
  }

  var mobileMenuStyles = styles.mobile_menu + " " + styles.headeritem + " " + styles.menu_icon

  return (
    <div>
      {/* I cant get this shit to work on mobile */}
      <div className={styles.header}>


        <div className={mobileMenuStyles} onClick={handleClick}>
          {click ? (
            <a className={styles.menu_icon} >Close Dashboard Menu</a>
          ) : (
            <a className={styles.menu_icon} >Open Dashboard Menu</a>
          )}
        </div>

        <div className={itemstyles}>
          <Link to="/dashboard/active" className={styles.headeritem}>Active Servers</Link>
          <Link to="/dashboard/get-started" class={styles.headeritem}>Set up a new server</Link>
          <Link to="/dashboard/account" class={styles.headeritem}>Account Settings</Link>
        </div>
      </div>
    </div>
  );
}

export default DashboardHeader;
